module.exports = __webpack_public_path__ + "img/logo_white.8e3f981.png";